//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            filterKey: '',
            items: [],
            loading: true,
            showAll: true
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('refresh-bank-reconciles', function () {
            return _this.load();
        });
        this.showAll = false;
    },


    methods: {
        add: function add() {
            Event.$emit('add-bank-reconcile');
        },
        update: function update(item) {
            if (item.status != 'Complete') {
                Event.$emit('update-bank-reconcile', item.id);
            } else {
                Event.$emit('completed-bank-reconcile', item.id);
            }
        },
        showCompleted: function showCompleted(item) {},
        load: function load() {
            var _this2 = this;

            this.loading = true;
            axios.post('/prototype/accounting/general-ledger/reconcile/index').then(function (response) {
                _this2.items = response.data;
                _this2.loading = false;
            });
        }
    },

    computed: {

        filteredData: function filteredData() {
            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.items;

            if (!this.showAll) {
                data = data.filter(function (reconcile) {
                    return reconcile.status != 'Complete';
                });
            }

            if (filterKey) {
                data = data.filter(function (row) {
                    return String(row.bank_account.account_name).toLowerCase().indexOf(filterKey) > -1;
                });
            }
            return data;
        }

    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reconcile/ReconcileList.vue
// module id = eQ9f
// module chunks = 0 1